export const PROFILE_KEY = 'profile_v2'

export default {
  namespaced: true,

  state: () => ({
    blankProfile: {
      _id: '',
      email: '',
      displayName: '',
      isAdmin: false,
      token: '',
    },
    profile: {
      _id: '',
      email: '',
      displayName: '',
      isAdmin: false,
      token: '',
    },
  }),

  getters: {
    isAdmin(state) {
      return state.profile.isAdmin
    },
    token(state) {
      return state.profile.token
    },
  },

  mutations: {
    setProfile(state, profile) {
      state.profile = {
        ...profile,
        token: profile.token || state.profile.token,
      }
    },
    setToken(state, token) {
      state.profile.token = token
    },
  },

  actions: {
    async loadProfile({ commit, dispatch }, tenant) {
      const data = await dispatch('getStoredProfiles')
      if (data[tenant]) {
        commit('setProfile', data[tenant])
      }
    },
    async saveProfile({ commit, dispatch, state }, { tenant, profile }) {
      commit('setProfile', profile)

      const data = await dispatch('getStoredProfiles')
      data[tenant] = state.profile
      dispatch('storeProfile', data)
    },
    async clearProfile({ commit, state, dispatch }, tenant) {
      const data = await dispatch('getStoredProfiles')
      delete data[tenant]
      dispatch('storeProfile', data)

      commit('setProfile', state.blankProfile)
    },

    getStoredProfiles() {
      let data
      try {
        data = JSON.parse(localStorage.getItem(PROFILE_KEY))
      } catch {
        // Do nothing
      }

      return data || {}
    },

    storeProfile(ctx, data) {
      localStorage.setItem(PROFILE_KEY, JSON.stringify(data))
    },
  },
}
